/* Etiquetas multiidoma en castellano. */
export default {
  "contactView.name": "Nombre",
  "contactView.phone": "Móvil",
};
